import { render, staticRenderFns } from "./9b_doc.vue?vue&type=template&id=3a7273e3&scoped=true"
import script from "./9b_doc.vue?vue&type=script&lang=js"
export * from "./9b_doc.vue?vue&type=script&lang=js"
import style0 from "./9b_doc.vue?vue&type=style&index=0&id=3a7273e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7273e3",
  null
  
)

export default component.exports